import { render } from "./DiarioDeEmocoesPrivacyPolicyPT.vue?vue&type=template&id=1a2befda"
import script from "./DiarioDeEmocoesPrivacyPolicyPT.vue?vue&type=script&lang=js"
export * from "./DiarioDeEmocoesPrivacyPolicyPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__